import { useMemo } from 'react'

import {
  useCreateFormFieldRelationshipMutation,
  useGetFieldRelationshipsQuery,
  useRemoveFormFieldRelationshipMutation
} from '../services/formFieldRelationships'

export function useManageFieldRelationships({ fieldId }) {
  const { data: fieldRelationships, isLoading } = useGetFieldRelationshipsQuery({ fieldId })

  const [createFormFieldRelationship, { isLoading: createLoading }] = useCreateFormFieldRelationshipMutation()
  const [removeFormFieldRelationship, { isLoading: removeLoading }] = useRemoveFormFieldRelationshipMutation()

  const addFieldRelationship = async ({ mainFieldId, relatedFieldId }) => {
    const payload = { mainFieldId, relatedFieldId }
    await createFormFieldRelationship({ payload })
  }

  const removeAllRelationships = async ({ targetFieldId }) => {
    const payload = { mainFieldId: targetFieldId, relatedFieldId: targetFieldId }
    await removeFormFieldRelationship({ payload })
  }

  const removeFieldRelationship = async ({ mainFieldId, relatedFieldId }) => {
    const payload = { mainFieldId, relatedFieldId }
    await removeFormFieldRelationship({ payload })
  }

  const hasRelationships = useMemo(
    () =>
      fieldRelationships &&
      (Object.keys(fieldRelationships.main).length > 0 || Object.keys(fieldRelationships.related).length > 0),
    [fieldRelationships?.main, fieldRelationships?.related, fieldId]
  )

  return {
    fieldRelationships: fieldRelationships?.main,
    isLoading: isLoading || createLoading || removeLoading,
    addFieldRelationship,
    removeFieldRelationship,
    removeAllRelationships,
    hasRelationships
  }
}
